import React, { useEffect } from "react";
import { useUiState } from "../../../helpers/useUiState";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, theme, Typography } from "antd";
import { useAuthProvider } from "../hooks/useAuthProvider";
import { useAuthSrv } from "pages/Auth/hooks/useAuthSrv";
import { useTranslation } from "react-i18next";
const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const AuthB2C = () => {
  const { isAppLoading } = useUiState();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { authStep } = state ?? {};
  const {
    generateMemberName,
  } = useAuthSrv();
  const { updateAuthSession, updateAuthWizard } = useAuthProvider();
  const { token } = useToken();
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const styles = {
    container: {
      margin: "0 auto",
      padding: screens.md
        ? `${token.paddingXL}px`
        : `${token.sizeXXL}px ${token.padding}px`,
      width: "380px",
      zIndex: 100,
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      marginBottom: token.marginXL,
    },
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      height: screens.sm ? "100vh" : "100vh",
      padding: screens.md ? `${token.sizeXXL}px 0px` : "0px",
    },
    text: {
      color: token.colorTextSecondary,
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
  };
  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get("access_token");
  console.log("accessToken", accessToken);

  const getMemberName = async () => {
    try {
      const res = await generateMemberName();
      console.log("generateMemberName response:", res);
      isAppLoading(false);
      if (res.data && res.data.UserName) {
        return res.data.UserName;
      } else {
        console.error("UserName not found in response", res.data);
      }
    } catch (e) {
      console.error("Error fetching member name:", e);
      const navParams = {
        state: {
          errorCode: "410",
          errorTitle: "The requested resource is no longer available",
          errorDescription: "The requested resource is no longer available",
        },
      };
    }
    return null;
  };

  useEffect(() => {
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
    }

    const accessTokenNew = localStorage.getItem("accessToken");
    if (accessTokenNew) {
      (async () => {
        const memberName = await getMemberName();
        console.log("memberName", memberName);

        const authSession = {
          auth_progress: "PROGRESS",
          access_token: accessToken,
          user_name: memberName,
        };

        updateAuthSession(authSession);
        updateAuthWizard(authStep?.onSuccess);
        navigate("/member/activities");
      })();
    } else {
      window.location.href = `${process.env.REACT_APP_API_ENDPOINT}/${process.env.REACT_APP_URL_SEGMENT}callback=${process.env.REACT_APP_CALLBACK_URL}`;
    }
  }, [
    accessToken,
    authStep,
    navigate,
    updateAuthSession,
    updateAuthWizard,
    isAppLoading,
  ]);
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <Title style={styles.title}>{t("AUTHANONYMOUS.TITLE")}</Title>
          <Text style={styles.text}>{t("AUTHANONYMOUS.CONTENT")}</Text>
        </div>
      </div>
    </section>
  );
};
export default AuthB2C;
